<template>
  <div class="acomodarHora">
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <hr style="height: 5px;
    background-color: #17A2B8;
    margin: 0px"
    >
  </div>

</template>

<script>
export default {
  name: "lineaHora",
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,
  }),
  created() {
    this.debug = this.$localStorageService.getDebug();
  },
}
</script>

<style scoped>
.acomodarHora{
  float: right;
  z-index: 50;
  color: red;
  position: absolute;
  /*width: 90em;*/
  width: 100%;
  /*height: 20px;*/
}

.acomodarHora::after {
  content: "";
  position: absolute;
  top: -2px;
  right: -5px;
  width: 11px;
  height: 11px;
  background-color: #17A2B8;
  border-radius: 50%;
}
</style>